import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetDashboard } from 'applications/GSP/pages/Dashboard/hooks';
import { AnalyticsEvent } from 'applications/GSP/shared/constants/analytics';
import { useAnalytics } from 'applications/GSP/shared/hooks/analytics';
import { Skeleton } from 'shared/components/DataRow';
import { Skeletons } from 'shared/components/Skeletons';
import { EmptyState } from 'shared/components/Tile';
import { isArrayEmpty } from 'shared/utils/common';

import { AssignmentRow } from './components/AssignmentRow/AssignmentRow';
import { Wrapper } from './components/Wrapper';
import { SKELETONS_AMOUNT } from './constants';

import type { FC } from 'react';

export const Content: FC = () => {
  const { isLoading, data } = useGetDashboard();
  const { t } = useTranslation();
  const analytics = useAnalytics();

  const onClick = useCallback(() => {
    analytics.track(
      AnalyticsEvent.DashboardUpcomingAssignmentsAssignmentClicked,
    );
  }, [analytics]);

  if (isLoading) {
    return (
      <Wrapper>
        <Skeletons element={<Skeleton />} amount={SKELETONS_AMOUNT} />
      </Wrapper>
    );
  }

  if (isArrayEmpty(data?.upcomingAssignments)) {
    return (
      <EmptyState
        header={t(
          'GSP.pages.dashboard.widgets.upcomingAssignments.emptyState.header',
        )}
        description={t(
          'GSP.pages.dashboard.widgets.upcomingAssignments.emptyState.description',
        )}
      />
    );
  }

  return (
    <Wrapper>
      {data?.upcomingAssignments.map(assignment => (
        <AssignmentRow {...assignment} key={assignment.id} onClick={onClick} />
      ))}
    </Wrapper>
  );
};
